<div class="switch-container">
  <div class="switch-option" *ngFor="let text of texts; let i = index" [class.active]="activeIndex === i" (click)="handleClick(i)">
    <div class="text-container">
      <span>{{text}}</span>
    </div>
  </div>
</div>
<div class="focus-div" [style.width]="focusDivWeight" [style.left]="focusDivLeft" [style.transition]="focusDivTransition">
  <div class="text-container">
    <span>{{texts[activeIndex]}}</span>
  </div>
</div>
